export enum WorkspaceFlavour {
  /**
   * New Pique Workspace using Nest.js Server.
   */
  PIQUE_CLOUD = 'pique-cloud',
  LOCAL = 'local',
}
